const NAMESPACE = 'indicoo-cache';

const read = (key) => {
  try {
    const raw = window.localStorage.getItem(`${NAMESPACE}:${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const write = (key, data) => {
  try {
    window.localStorage.setItem(`${NAMESPACE}:${key}`, JSON.stringify({ data, savedAt: Date.now() }));
  } catch (error) {
    // localStorage indisponível (modo privado, quota cheia): cache é best-effort, ignora
  }
};

/**
 * Lê o último valor cacheado para `key`, se existir.
 * `isFresh` indica se ainda está dentro do `ttlMs`; um valor "stale" ainda é
 * retornado de propósito, para ser exibido enquanto uma chamada real acontece
 * em paralelo (útil quando a API está em standby e o primeiro request demora).
 */
export const getCached = (key, ttlMs) => {
  const entry = read(key);
  if (!entry) return null;
  return { data: entry.data, isFresh: Date.now() - entry.savedAt < ttlMs };
};

export const setCached = (key, data) => write(key, data);

/**
 * Stale-while-revalidate: mostra o último dado bom conhecido (se houver)
 * imediatamente via `onData(data, { fromCache: true })`, e sempre dispara
 * `fetcher` para buscar o dado atual, atualizando o cache ao final.
 * Se não houver nada em cache, aguarda `fetcher` normalmente.
 */
export const fetchWithStaleCache = async (key, { ttlMs, fetcher, onData }) => {
  const cached = getCached(key, ttlMs);

  if (cached) {
    onData(cached.data, { fromCache: true, isFresh: cached.isFresh });
  }

  const fresh = await fetcher();
  onData(fresh, { fromCache: false });
  setCached(key, fresh);
  return fresh;
};
